import styled from 'styled-components';
import { breakpoints } from 'hfs-common-ui';
import { zDrawers, headerHeight, shadows } from '~/styled';

interface Props {
  $shadow: boolean;
}

export const Header = styled.header<Props>`
  position: sticky;
  top: 0;
  z-index: ${() => zDrawers};
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: ${({ $shadow }) => ($shadow ? shadows.boxShadow2 : 'none')};
  max-height: ${headerHeight};
  @media (max-width: ${breakpoints.l}px) {
    & > header > nav > div:nth-child(2) {
      padding: 0;
    }
  }
`;
